import config from '../../config/config';

export const PAYOUT_ACCOUNTS_LOAD = 'PAYOUT_ACCOUNTS/PAYOUT_ACCOUNT_LOAD';
export const PAYOUT_ACCOUNTS_SUCCESS = 'PAYOUT_ACCOUNTS/PAYOUT_ACCOUNT_SUCCESS';
export const PAYOUT_ACCOUNTS_FAILURE = 'PAYOUT_ACCOUNTS/PAYOUT_ACCOUNT_FAILURE';

export function getPayoutAccountsFailureActionCreator(error) {
    return {
        error,
        type: PAYOUT_ACCOUNTS_FAILURE
    };
}

export function getPayoutAccountsSuccessActionCreator({ rows: payoutAccounts }) {
    return {
        payoutAccounts,
        type: PAYOUT_ACCOUNTS_SUCCESS
    };
}

export function getPayoutAccounts() {
    return {
        failureActionTypeOrCreator: getPayoutAccountsFailureActionCreator,
        fetchParams: {
            url: `${config.payoutApiUrl}/account?limit=100`
        },
        loadActionTypeOrCreator: PAYOUT_ACCOUNTS_LOAD,
        successActionTypeOrCreator: getPayoutAccountsSuccessActionCreator
    };
}
